import React from 'react';
import PropTypes from 'prop-types';

import MediaPlayer from '../../components/player/MediaPlayer.jsx';
import { IMAGE, AUDIO, VIDEO } from '../../constants/fileTypes';

const FilePreview = ({ type, url, text }) => {
  const openFile = () => window.open(url);

  switch (type) {
    case IMAGE:
      return (
        <a
          className="message-img"
          target="_blanc"
          aria-label={text}
        >
          <img style={{ cursor: 'pointer' }} src={url} alt="message-file" onClick={openFile} />
        </a>

      );
    case AUDIO:
      return (
        <MediaPlayer isAudio src={url} text={text} />
      );
    case VIDEO:
      return (
        <MediaPlayer isVideo src={url} text={text} />
      );
    default:
      return null;
  }
};

if (process.env.NODE_ENV !== 'production') {
  FilePreview.propTypes = {
    type: PropTypes.oneOf([IMAGE, AUDIO, VIDEO]).isRequired,
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
  };
}

export default FilePreview;
